package com.fireavert.properties.property_details.client.presentation

import com.fireavert.common.ViewModel
import com.fireavert.fire_risk.data_models.TenantFireRiskDataModel
import com.fireavert.properties.shared.data_models.Mode
import com.fireavert.properties.shared.data_models.PmsType
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow

class PropertyDetailsViewModel : ViewModel(), PropertyDetailsScreen {
    private val _viewState = MutableStateFlow(PropertyDetailsViewState())
    val viewState = _viewState.asStateFlow()

    override var fireRiskModel: List<TenantFireRiskDataModel>
        get() = viewState.value.fireRiskModel
        set(value) {}
    override val scope: CoroutineScope
        get() = viewModelScope

    override fun setPropertyName(name: String) {
        _viewState.value = _viewState.value.copy(propertyName = name)
    }

    override fun setLoadingStatus(value: Boolean) {
        _viewState.value = _viewState.value.copy(isLoading = value)
    }

    override fun setPropertyMode(mode: Mode) {
        _viewState.value = _viewState.value.copy(propertyMode = mode)
    }

    override fun setPropertyTotalUnits(value: Int) {
        _viewState.value = _viewState.value.copy(propertyTotalUnits = value)
    }
    override fun setIdAdmin(value: Boolean) {
        _viewState.value = _viewState.value.copy(isAdmin = value)
    }

    override fun setTestModeError(value: String) {
        _viewState.value = _viewState.value.copy(testModeError = value)
    }

    override fun closeTestModeDialog(value: Boolean) {
        _viewState.value = _viewState.value.copy(isTestModeDialogOpen = value)
    }

    override fun setPmsType(pmsType: PmsType?) {
        _viewState.value = _viewState.value.copy(pmsType = pmsType)
    }

    override fun setPropertyDefaultStoveCookingTimeMinutes(defaultStoveCookingTimeMinutes: Int?) {
        _viewState.value = _viewState.value.copy(
            propertyDefaultStoveCookingTimeMinutes = defaultStoveCookingTimeMinutes ?: 40
        )
    }
}